import { format } from "date-fns";
import { AnyDate, DatePickerCalendarLocale, DatePickerCalendarProps } from "../../DatePickerCalendar/DatePickerCalendar.types";
import { DateRange } from "react-day-picker";
import useTranslate from "ui/locale/hooks/useTranslate";

export interface UseDatePickerDropdownLabelParams {
    calendarMode: DatePickerCalendarProps["mode"];
    date: AnyDate | undefined;
    locale: DatePickerCalendarLocale;
    placeholder?: string;
}

export default function useDatePickerDropdownLabel({ calendarMode, date, locale, placeholder }: UseDatePickerDropdownLabelParams) {
    const translate = useTranslate();
    const dropdownPlaceholder = placeholder || translate("selectADate");

    if (!date) return placeholder || translate("selectADate");

    switch (calendarMode) {
        case "range": {
            const range = date as DateRange;

            if (!range.from || !range.to) return dropdownPlaceholder;

            const startDate = format(range.from, "d, LLL", { locale });
            const endDate = format(range.to, "PP", { locale });

            return `${startDate} – ${endDate}`;
        }
        default:
            throw new Error("function not implemented yet");
    }
}
